export default __webpack_public_path__ + "f142b536f26f109b9c0577ecbdab121e.png";